
  const NEAR_BOTTOM_PX = 120
  const AT_BOTTOM_PX = 8
  const READ_DELAY_MS = 1000
  const READ_MAX_WAIT_MS = 5000

  export default {
    mounted() {
      this.catchUp = document.getElementById("chat-catch-up")
      this.anchor = null
      this.pinned = true
      this.readTimer = null
      this.readSince = null

      this.toBottom()

      this.observer = new ResizeObserver(() => { if (this.pinned) this.toBottom() })
      this.observer.observe(document.getElementById("chat-messages"))

      this.catchUp.addEventListener("click", () => this.toBottom())

      this.el.addEventListener("click", (event) => {
        if (event.target.closest("#chat-load-older")) this.rememberPosition()
      })

      this.el.addEventListener("scroll", () => {
        this.pinned = this.nearBottom()
        if (this.pinned) {
          this.hideCatchUp()
          this.requestRead()
        }
      }, {passive: true})

      this.onVisible = () => {
        if (document.visibilityState === "visible" && this.pinned) this.requestRead()
      }
      document.addEventListener("visibilitychange", this.onVisible)

      this.handleEvent("chat:appended", () => {
        if (this.pinned) {
          this.toBottom()
          this.requestRead()
        } else {
          this.showCatchUp()
        }
      })

      this.handleEvent("chat:replied", () => {
        if (this.pinned) this.requestRead()
      })

      this.handleEvent("chat:opened", () => {
        this.toBottom()
        this.requestRead()
      })

      this.handleEvent("chat:sent", () => this.toBottom())

      this.handleEvent("chat:older_loaded", () => this.restorePosition())
    },

    destroyed() {
      this.observer?.disconnect()
      clearTimeout(this.readTimer)
      document.removeEventListener("visibilitychange", this.onVisible)
    },

    requestRead() {
      const now = Date.now()
      if (this.readSince === null) this.readSince = now
      clearTimeout(this.readTimer)
      this.readTimer = setTimeout(() => this.pushRead(), Math.min(READ_DELAY_MS, this.readSince + READ_MAX_WAIT_MS - now))
    },

    pushRead() {
      this.readTimer = null
      this.readSince = null
      if (document.visibilityState === "visible" && this.atBottom()) this.pushEvent("chat:read", {}).catch(() => {})
    },

    nearBottom() {
      return this.distanceToBottom() < NEAR_BOTTOM_PX
    },

    atBottom() {
      return this.distanceToBottom() < AT_BOTTOM_PX
    },

    distanceToBottom() {
      return this.el.scrollHeight - this.el.scrollTop - this.el.clientHeight
    },

    toBottom() {
      this.pinned = true
      this.hideCatchUp()
      requestAnimationFrame(() => {
        this.el.scrollTop = this.el.scrollHeight
      })
    },

    showCatchUp() {
      this.catchUp.classList.remove("hidden")
      this.catchUp.classList.add("flex")
    },

    hideCatchUp() {
      this.catchUp.classList.add("hidden")
      this.catchUp.classList.remove("flex")
    },

    rememberPosition() {
      this.anchor = {height: this.el.scrollHeight, top: this.el.scrollTop}
    },

    restorePosition() {
      if (!this.anchor) return
      this.el.scrollTop = this.el.scrollHeight - this.anchor.height + this.anchor.top
      this.anchor = null
    }
  }
